import { makeStyles } from "@material-ui/core";

import { ButtonLinkProps } from "./ButtonLink";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: "auto",
      color: (props: ButtonLinkProps) =>
        props.textColor !== undefined
          ? props.textColor
          : theme.palette.common.white,
      border: "none",
      background: (props: ButtonLinkProps) =>
        props.background !== undefined
          ? props.background
          : theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: ".8rem",
      padding: "10px 12px 10px 12px",
      textDecoration: "none",
      borderRadius: 4,

      "&:hover": {
        color: (props: ButtonLinkProps) =>
          props.textColor !== undefined
            ? props.textColor
            : theme.palette.common.white,
        opacity: 0.9,
        textDecoration: "none",
      },
    },
  }),
  { name: "button-link-style", flip: null }
);
